import { dayjs, localStorage } from '@mdc/services';

const addCountryCodeToLanguage = (lng) => {
    switch (lng) {
        case 'en':
            return `${lng}-US`;
        case 'ja':
            return `${lng}-JP`;
        default:
            return lng;
    }
};

export default {
    name: 'lngDetector',

    lookup(options) {
        let langFound;
        if (typeof window !== 'undefined') {
            let query = window.location.search.substring(1);
            const params = query.split('&');
            params?.map((param) => {
                const pos = param.indexOf('=');
                if (pos > 0) {
                    const key = param.substring(0, pos);
                    if (key === options.lookupQuerystring) {
                        langFound = param.substring(pos+1);
                    }
                }
            });
        }
        if (langFound) {
            switch (langFound) {
                case 'en':
                    return 'en-US';
                case 'ja':
                    return 'ja-JP';
            }
        } else {
            langFound = localStorage.getItem(options.lookupLocalStorage);
        }
        return langFound;
    },

    cacheUserLanguage(lng, options) {

        localStorage.setItem(options.lookupLocalStorage, addCountryCodeToLanguage(lng));
        dayjs.locale(lng.split('-')[0]);

        const queryLang = `lang=${lng.split('-')[0]}`;

        if (typeof window !== 'undefined') {
            if (window.location.hash) {
                return;
            }

            let query = window.location.search.substring(1);
            let shouldUpdateLangParam = false;
            const params = query.split('&');

            params?.map((param) => {
                const pos = param.indexOf('=');
                if (pos > 0) {
                    const key = param.substring(0, pos);
                    if (key === options.lookupQuerystring && !shouldUpdateLangParam) {
                        shouldUpdateLangParam = true;
                        query = query.replace(/(lang).+(?=&)*/, queryLang);
                        if (query[query.length - 1] === '&') {
                            query = query.slice(0, -1);
                        }
                    }
                }
            });

            if (!shouldUpdateLangParam) {
                if (query === '') {
                    query += queryLang;
                } else {
                    query += `&${queryLang}`;
                }
            }

            window && window.history.replaceState('', '', `?${query}`);

        }
    }
};
